import React from 'react'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            error: false
        }
    }

    static getDerivedStateFromError = error => {
        return { error: true }
    }

    render() {
        if (this.state.error) return <h2 style={{margin: '30px'}}>{this.props.message}</h2>
        return this.props.children
    }
}

export default ErrorBoundary
